import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Card,
  Container,
  Row,
  Col,
  Table,
  Form,
  Button,
  Modal,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle, faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { useSelector, useDispatch } from "react-redux";
import {
  postPersonnel,
  postPersonnelByPerson,
  updatePersonnelReport,
  postPersonnelExcel,
  resetPersonnelReport,
  updateLeaveTaken,
  resetLeaveTaken,
  updateReason,
  resetReason,
  addReasonLate,
} from "./PersonnelSlice";
import { triggerBase64Download } from "common-base64-downloader-react";
import SideMenu from "../../UI/SIdeMenu";
import Navibar from "../../UI/Navibar";
import Footer from "../../UI/Footer";
import axios from "axios";
import jwt_decode from "jwt-decode";
// import moment from 'moment';
import './Personnel.css';

function PersonnelComponentNormal() {
  const dispatch = useDispatch();
  const [table, setTable] = useState([]);

  const { personnels, personnelReport, leaveTaken, reason } = useSelector(
    (state) => state.personnelSlice
  );
  const { persons, fromdate, todate } = personnelReport;
  const { date, id, reason_late } = reason;

  const [showAdd, setShowAdd] = useState(false);
  const [showView, setShowView] = useState(false);

  const accessToken = localStorage.getItem("access_token");
  const token = jwt_decode(accessToken);
  const name = token?.family_name + " " + token?.given_name;

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();

  // const [selectedMonth, setSelectedMonth] = useState(moment(new Date()).format("MMMM"));
  // const [selectedMonth, setSelectedMonth] = currentDate.getMonth();
  // // const months = moment.months();
  // const months = currentMonth;

  // Set the initial state to the numeric value of the current month
  const [selectedMonth, setSelectedMonth] = useState(currentDate.getMonth() + 1); // +1 because getMonth() is zero-indexed

  const monthOptions = [
    { value: 1, label: "JANUARY" },
    { value: 2, label: "FEBRUARY" },
    { value: 3, label: "MARCH" },
    { value: 4, label: "APRIL" },
    { value: 5, label: "MAY" },
    { value: 6, label: "JUNE" },
    { value: 7, label: "JULY" },
    { value: 8, label: "AUGUST" },
    { value: 9, label: "SEPTEMBER" },
    { value: 10, label: "OCTOBER" },
    { value: 11, label: "NOVEMBER" },
    { value: 12, label: "DECEMBER" },
  ];

  // const [selectedYear, setSelectedYear] = useState(moment(new Date()).format("YYYY"));
  const [selectedYear, setSelectedYear] = useState(currentYear);
  // const currentYear = moment().year();
  const years = [currentYear - 1, currentYear];

  useEffect(() => {
    dispatch(postPersonnel(name));
    }, [name])

  useEffect(() => {
    const fromDate = `${selectedYear}-${selectedMonth}-01`;
    const lastDayOfMonth = new Date(selectedYear, selectedMonth, 0+1); // Month is zero-indexed here
    const toDate = lastDayOfMonth.toISOString().slice(0, 10);

    const entity = { ...personnelReport, fromdate: fromDate, todate: toDate };
    console.log(entity)
    dispatch(updatePersonnelReport(entity));
   
    const entity2 = { ...leaveTaken, from_date: fromDate, to_date: toDate };
    dispatch(updateLeaveTaken(entity2));
  }, [selectedMonth, selectedYear]);

  const dayTypeMapping = {
    "WORKDAY": "W",
    "HOLIDAY": "H",
    "RESTDAY": "R"
  };

  const fullNameMapping = {
    "W": "WORKDAY",
    "H": "HOLIDAY",
    "R": "RESTDAY"
  };


  const weekday = [
    "SUN",
    "MON",
    "TUE",
    "WED",
    "THU",
    "FRI",
    "SAT",
  ];

  const handleChangeMonth = (e) => {
    setSelectedMonth(Number(e.target.value)); // Convert to number for consistency
  };

  const handleChangeYear = (e) => {
    setSelectedYear(e.target.value);
  };

  const handleClickSearch = () => {
    const selectedPersonnel = personnels.find(person => person.label === name);
    console.log(selectedPersonnel)
    const entity = { ...personnelReport, persons: { id: selectedPersonnel?.value } };
    console.log(entity);
    dispatch(postPersonnelByPerson(entity)).then((res) => {
      console.log(res);
      console.log(res.payload);
      let personLists = res.payload;
      console.log(personLists);
      const entity2 = {
        ...leaveTaken,
        from_date: personnelReport.fromdate,
        to_date: personnelReport.todate,
        sid: selectedPersonnel?.value2
      };
      console.log(entity2);
      setTable(personLists);
      // axios
      //   .post(
      //     "http://192.168.5.149/apiv2/public/index.php/staffonleave/employeeVacationBySID",
      //     entity2
      //   )
      //   .then((res) => {
      //     console.log(res.data);
      //     const leave = res.data;

      //     const result = personLists.map((element2) => {
      //       const matchingLeave = leave.find((element1) => {
      //         const newDate = element1.datetime.date.split("T")[0];
      //         return newDate === element2.cdate;
      //       });

      //       let ampm = "";

      //       if (matchingLeave) {
      //         if (
      //           (matchingLeave.leave_application.from_ampm === "AM" &&
      //             matchingLeave.leave_application.to_ampm === "AM") ||
      //           (matchingLeave.leave_application.from_ampm === "PM" &&
      //             matchingLeave.leave_application.to_ampm === "PM")
      //         ) {
      //           ampm = "Half day";
      //         } else if (
      //           matchingLeave.leave_application.from_ampm === "AM" &&
      //           matchingLeave.leave_application.to_ampm === "PM"
      //         ) {
      //           ampm = "1 day";
      //         }
      //       }

      //       return {
      //         ...element2,
      //         leaveTaken: ampm,
      //       };
      //     });
      //     setTable(result);
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });
    });
  };

  const handleExportExcel = () => {
    const selectedPersonnel = personnels.find(person => person.label === name);
    //console.log(selectedPersonnel)
    const entity = { ...personnelReport, persons: { id: selectedPersonnel?.value } };
    //const entity = { ...personnelReport };
    dispatch(postPersonnelExcel(entity)).then((res) => {
      console.log(res);
      console.log(res.payload);
      const base64EXCEL =
        "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
        res.payload;
      triggerBase64Download(
        base64EXCEL,
        "personnel_report" + "_" + new Date().toISOString().slice(0, 10)
      );
    });
  };

  const handleCloseAdd = () => {
    dispatch(resetReason());
    setShowAdd(false);
  };

  const handleCloseView = () => {
    dispatch(resetReason());
    setShowView(false);
  };

  const handleBtnReason = (date, id) => {
    const entity = { ...reason, date: date, id: id};
    console.log(entity);
    dispatch(updateReason(entity));
    setShowAdd(true);
  };

  const handleBtnViewReason = (date, id, reasons) => {
    const entity = { ...reason, date: date, id: id, reason_late: reasons};
    console.log(entity);
    dispatch(updateReason(entity));
    setShowView(true);
  };

  const handleReasonChange = (e) => {
    const entity = { ...reason, reason_late: e.target.value};
    console.log(entity);
    dispatch(updateReason(entity));
  };

  const handleBtnSumbitReason = async (e) => {
    const entity = { ...reason };
    console.log(entity);
    await dispatch(addReasonLate(entity));
    handleClickSearch();
    dispatch(resetReason());
    setShowAdd(false);
  };

  const handleBtnUpdateReason = async (e) => {
    const entity = { ...reason };
    console.log(entity);
    await dispatch(addReasonLate(entity));
    handleClickSearch();
    dispatch(resetReason());
    setShowView(false);
  };

  const compareTime = (time) => {
    if (!time || time === "") {
      return true;
    }
    const [hours, minutes, seconds] = time.split(":").map(Number);
    const inputDate = new Date(0, 0, 0, hours, minutes, seconds);
    const referenceDate = new Date(0, 0, 0, 8, 31, 0);
    return inputDate < referenceDate;
  };

  // Function to check if time_in is late and format it accordingly
  const formatTime = (time) => {
    const lateTime = '08:30:59';
    return time > lateTime ? `**${time}**` : time;
  };

  return (
    <div className="Div">
      <Container fluid>
        <Row>
          <Col xs={12} className="fixed-top">
            <Navibar />
          </Col>
        </Row>
        <Row>
          <Col
            xs={2}
            id="sidebar-wrapper"
            className="sidemenu"
            style={{ marginTop: "50px" }}
          >
            <SideMenu />
          </Col>
          <Col>
            <Card className="content">
              <Form>
                <Container>
                  <Row className="mb-3 mt-3">
                    <Col md={12}>
                      <h4>PERSONNEL REPORT</h4>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={3}>EMPLOYEE:</Col>
                    <Col md={9}>
                        <Form.Control readOnly value={name} />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={3}>
                      <Form.Label>MONTH:</Form.Label>
                    </Col>
                    <Col md={3}>
                        <Form.Select value={selectedMonth} onChange={handleChangeMonth}>
                          {monthOptions.map((month) => (
                            <option key={month.value} value={month.value}>
                              {month.label}
                            </option>
                          ))}
                        </Form.Select>
                    </Col>
                    <Col md={3}>
                      <Form.Label>YEAR:</Form.Label>
                    </Col>
                    <Col md={3}>
                        <Form.Select 
                            value={selectedYear}
                            onChange={handleChangeYear}
                            >
                            {years.map((year, index) => (
                                <option key={index} value={year}>
                                    {year}
                                </option>
                            ))}
                        </Form.Select>
                    </Col>
                  </Row>
                  <Row className="justify-content-md-center mb-3">
                    <Col xs="auto" md={12}>
                      <Form.Group>
                        <Button
                          type="button"
                          bg="dark"
                          variant="dark"
                          onClick={handleClickSearch}
                        >
                          SEARCH
                        </Button>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Card>
                    <Table bordered responsive>
                      <thead>
                        <tr className="tableheader">
                          <th className="text-center">Date</th>
                          <th className="text-center">Weekday</th>
                          <th className="text-center">Day Type</th>
                          <th className="text-center">In</th>
                          <th className="text-center">Out</th>
                          <th className="text-center">Work</th>
                          <th className="text-center">Overtime</th>
                          <th className="text-center">Short</th>
                          <th className="text-center">Leave Taken</th>
                          <th className="text-center">Reason</th>
                        </tr>
                      </thead>
                      <tbody>
                        {table.map(
                          (
                            {
                              id,
                              cdate,
                              report_day_type,
                              time_in,
                              time_out,
                              overtime,
                              short_in,
                              short_out,
                              total_short,
                              total_work,
                              leaveTaken,
                              reason_late,
                              status
                            },
                            i
                          ) => (
                            <tr key={i} style={{ cursor: "pointer" }}>
                              <td>{cdate}</td>
                              <td>{weekday[new Date(cdate).getDay()]}</td>
                              <td title={fullNameMapping[dayTypeMapping[report_day_type]]}>
                                {dayTypeMapping[report_day_type]}
                              </td>
                              <td style={{ color: !compareTime(time_in) ? "red" : "black" }}>
                                {formatTime(time_in)}
                              </td>
                              <td>{time_out}</td>
                              <td>{total_work}</td>
                              <td>{overtime}</td>
                              <td>{total_short}</td>
                              {/* <td>{leaveTaken}</td> */}
                              <td>
                                {status == 1 ? "" : status == 2 ? "AM" : status == 3 ? "PM" : status == 4 ? "FULL" : ""}
                              </td>
                              <td>
                                {!time_in || compareTime(time_in) || report_day_type !== "WORKDAY" ? (
                                  "-"
                                ) : ( 
                                  reason_late ? (
                                    // <FontAwesomeIcon 
                                    //   icon={faCheckCircle} 
                                    //   onClick={() => handleBtnViewReason(cdate, id, reason_late)} 
                                    //   color="#28A745" // Green color for faCheck
                                    // />
                                    <td className="ellipsis" onClick={() => handleBtnViewReason(cdate, id, reason_late)}>
                                      {reason_late}
                                    </td>
                                  ) : (
                                    <FontAwesomeIcon 
                                      icon={faQuestionCircle} 
                                      onClick={() => handleBtnReason(cdate, id)}
                                      color="#DC3545"
                                    />
                                  )
                                )}
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </Table>
                  </Card>
                  <Row className="mb-3 mt-3">
                    <Col md={10}></Col>
                    <Col md={2}>
                      <Button
                        type="button"
                        bg="dark"
                        variant="dark"
                        onClick={() => handleExportExcel()}
                      >
                        Export Excel Report
                      </Button>

                      <Modal
                        show={showAdd}
                        onHide={handleCloseAdd}
                        backdrop="static"
                        keyboard={false}
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>ADD REASON</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <Form>
                            <Form.Group>
                              <Form.Label>DATE:</Form.Label>
                              <Form.Control
                                type="text"
                                value={date}
                                readOnly
                              />
                            </Form.Group>
                            <br/>
                            <Form.Group>
                              <Form.Label>REASON:</Form.Label>
                              <Form.Control
                                as="textarea"
                                name="reason"
                                value={reason_late}
                                onChange={handleReasonChange}
                              />
                            </Form.Group>
                          </Form>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button onClick={handleBtnSumbitReason}>SUBMIT</Button>
                        </Modal.Footer>
                      </Modal>

                      <Modal
                        show={showView}
                        onHide={handleCloseView}
                        backdrop="static"
                        keyboard={false}
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>REASON</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <Form>
                            <Form.Group>
                              <Form.Label>DATE:</Form.Label>
                              <Form.Control
                                type="text"
                                value={date}
                                readOnly
                              />
                            </Form.Group>
                            <br/>
                            <Form.Group>
                              <Form.Label>REASON:</Form.Label>
                              <Form.Control
                                as="textarea"
                                name="reason"
                                value={reason_late}
                                onChange={handleReasonChange}
                              />
                            </Form.Group>
                          </Form>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button onClick={handleBtnUpdateReason}>UPDATE</Button>
                        </Modal.Footer>
                      </Modal>
                      
                    </Col>
                  </Row>
                </Container>
              </Form>
            </Card>
          </Col>
        </Row>
      </Container>
      <Footer />
    </div>
  );
}

export default PersonnelComponentNormal;